package pl.mothdigital.neuronowi.common.utils

import pl.mothdigital.neuronowi.common.resources.StringResources
import pl.mothdigital.neuronowi.common.resources.UrlResources

/**
 * Generates schema.org JSON-LD structured data for the therapy center.
 *
 * Includes:
 * - LocalBusiness schema for local SEO
 * - Organization information
 * - Address, contact details, opening hours
 * - Social media profiles
 */
object StructuredData {
    /**
     * Returns the complete JSON-LD structured data string for the organization.
     */
    fun getOrganizationJsonLd(): String = """
{
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://neuronowi.pl/#organization",
  "name": "${StringResources.FULL_NAME}",
  "alternateName": "${StringResources.APP_NAME}",
  "description": "Specjalistyczna terapia dzieci, młodzieży i dorosłych w Zielonej Górze – logopedia, psychologia, neurologopedia, fizjoterapia, integracja sensoryczna.",
  "url": "https://neuronowi.pl",
  "telephone": "+48 500 124 500",
  "email": "${StringResources.CONTACT_SECTION_EMAIL}",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Fabryczna 17a/1",
    "addressLocality": "Zielona Góra",
    "postalCode": "65-410",
    "addressCountry": "PL"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 51.9356,
    "longitude": 15.5062
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "09:00",
      "closes": "19:00"
    }
  ],
  "sameAs": [
    "${UrlResources.FACEBOOK_NEURONOWI_URL}",
    "${UrlResources.INSTAGRAM_NEURONOWI_URL}"
  ],
  "priceRange": "$$",
  "areaServed": {
    "@type": "City",
    "name": "Zielona Góra"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Usługi terapeutyczne",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Logopedia",
          "description": "Terapia logopedyczna dla dzieci i dorosłych"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Neurologopedia",
          "description": "Specjalistyczna terapia neurologopedyczna"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Psychologia",
          "description": "Wsparcie psychologiczne dzieci, młodzieży i dorosłych"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Fizjoterapia",
          "description": "Fizjoterapia dziecięca i terapia manualna"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Integracja sensoryczna",
          "description": "Terapia integracji sensorycznej SI"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Terapia ręki",
          "description": "Terapia ręki dla dzieci i dorosłych"
        }
      }
    ]
  }
}
    """.trimIndent()
}
